import React from 'react';
import { Box } from '@material-ui/core';

interface Props {
  children: React.ReactNode;
}

const CustomDialogButtonsContainer: React.FC<Props> = ({ children }) => {
  return (
    <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
      {children}
    </Box>
  );
};

export default CustomDialogButtonsContainer;
